import { createRequestHelper } from '@utils/swr'
import { type UserResponse } from '../../../types/apiResponse'
import { type CosignApis } from '../../../types/apis'

const {
  useRequest,
  mutate,
} = createRequestHelper<CosignApis['get']['user'], UserResponse>({
  client: 'cosign',
  key: '/api/platform-sdk/user',
  isImmutable: true,
})

export const useRequestUser = useRequest
export const mutateAllUsers = mutate
